import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthProvider';
import { Loader } from '../common';
import { useAuthStore } from '../../stores/auth.store';

type Props = {
    children: React.ReactNode;
};

function ProtectedRoute({ children }: Props) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isLoggedIn } = useAuthStore();

    const { loadingAuthUser, authUser } = useAuth();

    useEffect(() => {
        if (loadingAuthUser) {
            return;
        }

        if (authUser) {
            if (!authUser?.userRole) {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                navigate(
                    `/auth/login?redirectUrl=${encodeURI(
                        window.location.pathname + window.location.search,
                    )}`,
                    { replace: true },
                );
                return;
            }
        }

        if (
            !isLoggedIn &&
            !loadingAuthUser &&
            window.location.pathname !== '/auth/login'
        ) {
            navigate(
                `/auth/login?redirectUrl=${encodeURI(
                    window.location.pathname + window.location.search,
                )}`,
                { replace: true },
            );
        }
    }, [isLoggedIn, loadingAuthUser, authUser, pathname, navigate]);

    if (loadingAuthUser || !authUser) {
        return (
            <div className="flex h-screen justify-center items-center">
                <Loader isPageLoader />
            </div>
        );
    }

    return children;
}

export default ProtectedRoute;
